import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "dropdown d-inline-block mr-1" }
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = {
  key: 0,
  class: "dropdown-item"
}
const _hoisted_7 = { class: "dropdown d-inline-block" }
const _hoisted_8 = { class: "dropdown-menu" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "card mt-2" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "card-title" }
const _hoisted_13 = {
  key: 0,
  class: "fa fa-lock text-danger",
  title: "Survey is closed"
}
const _hoisted_14 = {
  key: 1,
  class: "fa fa-unlock-alt text-success",
  title: "Survey is open"
}
const _hoisted_15 = { class: "card-text" }
const _hoisted_16 = { class: "text-primary" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "btn btn-sm btn-outline-secondary mr-1" }
const _hoisted_19 = { class: "dropdown d-inline-block" }
const _hoisted_20 = { class: "dropdown-menu" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "table table-bordered table-hover table-browser" }
const _hoisted_30 = { style: {"width":"30px"} }
const _hoisted_31 = { class: "form-check form-check-inline mr-0" }
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 0,
  class: "badge badge-secondary"
}
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { class: "btn-group" }
const _hoisted_38 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WeightsSetDependenciesViewer = _resolveComponent("WeightsSetDependenciesViewer")!
  const _component_WeightsSetEditor = _resolveComponent("WeightsSetEditor")!
  const _component_CriteriaSurveyAccessLinks = _resolveComponent("CriteriaSurveyAccessLinks")!
  const _component_CriteriaSurveyEmailSender = _resolveComponent("CriteriaSurveyEmailSender")!
  const _component_SubSurveysManagerDialog = _resolveComponent("SubSurveysManagerDialog")!
  const _component_SurveyEditorDialog = _resolveComponent("SurveyEditorDialog")!
  const _component_SurveyOpenerDialog = _resolveComponent("SurveyOpenerDialog")!
  const _component_SurveyCloserDialog = _resolveComponent("SurveyCloserDialog")!
  const _component_WeightsComparerDialog = _resolveComponent("WeightsComparerDialog")!
  const _component_WeightsViewerDialog = _resolveComponent("WeightsViewerDialog")!
  const _component_WeightsSetDeleter = _resolveComponent("WeightsSetDeleter")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _component_GoalNavigation = _resolveComponent("GoalNavigation")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_WeightsSetDependenciesViewer, { viewModel: _ctx.weightsSetDependenciesViewer }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_WeightsSetEditor, {
      viewModel: _ctx.weightsSetEditor,
      onNormalizeWeights: _ctx.handleNormalizeWeights,
      onCreateWeightsSet: _ctx.handleCreateWeightsSetCommand,
      onUpdateWeightsSet: _ctx.handleUpdateWeightsSetCommand
    }, null, 8 /* PROPS */, ["viewModel", "onNormalizeWeights", "onCreateWeightsSet", "onUpdateWeightsSet"]),
    _createVNode(_component_CriteriaSurveyAccessLinks, {
      viewModel: _ctx.criteriaSurveyAccessLinks,
      onShowEmailSender: _ctx.showCriteriaSurveyEmailSender,
      onDownloadLinks: _ctx.handleDownloadAccessLinks
    }, null, 8 /* PROPS */, ["viewModel", "onShowEmailSender", "onDownloadLinks"]),
    _createVNode(_component_CriteriaSurveyEmailSender, {
      viewModel: _ctx.criteriaSurveyEmailSender,
      onSendEmail: _ctx.handleSendEmailCommand
    }, null, 8 /* PROPS */, ["viewModel", "onSendEmail"]),
    _createVNode(_component_SubSurveysManagerDialog, {
      viewModel: _ctx.subSurveysManagerDialog,
      onIncludeSubSurvey: _ctx.handleIncludeSubSurveyCommand,
      onExcludeSubSurvey: _ctx.handleExcludeSubSurveyCommand,
      onChangeVoteStrength: _ctx.handleChangeSubSurveyVoteStrengthCommand
    }, null, 8 /* PROPS */, ["viewModel", "onIncludeSubSurvey", "onExcludeSubSurvey", "onChangeVoteStrength"]),
    _createVNode(_component_SurveyEditorDialog, {
      viewModel: _ctx.surveyEditorDialog,
      onDeleteSurvey: _ctx.handleDeleteSurveyCommand,
      onCreateSurvey: _ctx.handleCreateSurveyCommand,
      onUpdateSurvey: _ctx.handleUpdateSurveyCommand
    }, null, 8 /* PROPS */, ["viewModel", "onDeleteSurvey", "onCreateSurvey", "onUpdateSurvey"]),
    _createVNode(_component_SurveyOpenerDialog, {
      propOpened: _ctx.surveyOpenerSurveyId != null,
      propSurveyId: _ctx.surveyOpenerSurveyId,
      onStartSurvey: _ctx.handleStartSurveyCommand,
      onShowAccessLinks: _ctx.showAccessLinks,
      onCloseDialog: _cache[0] || (_cache[0] = ($event: any) => (_ctx.surveyOpenerSurveyId = null))
    }, null, 8 /* PROPS */, ["propOpened", "propSurveyId", "onStartSurvey", "onShowAccessLinks"]),
    _createVNode(_component_SurveyCloserDialog, {
      propOpened: _ctx.surveyCloserSurveyId != null,
      propSurveyId: _ctx.surveyCloserSurveyId,
      onStopSurvey: _ctx.handleStopSurveyCommand,
      onCloseDialog: _cache[1] || (_cache[1] = ($event: any) => (_ctx.surveyCloserSurveyId = null))
    }, null, 8 /* PROPS */, ["propOpened", "propSurveyId", "onStopSurvey"]),
    _createVNode(_component_WeightsComparerDialog, {
      propOpened: _ctx.weightsComparerOpened,
      propRm: _ctx.weightsComparer,
      onCloseDialog: _cache[2] || (_cache[2] = ($event: any) => (_ctx.weightsComparerOpened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propRm"]),
    _createVNode(_component_WeightsViewerDialog, {
      propOpened: _ctx.weightsViewerOpened === true,
      propRm: _ctx.weightsViewer,
      onExportWeightssetWeights: _ctx.handleExportWeightsToXlsFromWeightsSetCommand,
      onExportSurveyWeights: _ctx.handleExportWeightsToXlsFromSurveyVotesCommand,
      onCloseDialog: _cache[3] || (_cache[3] = ($event: any) => (_ctx.weightsViewerOpened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propRm", "onExportWeightssetWeights", "onExportSurveyWeights"]),
    _createVNode(_component_WeightsSetDeleter, {
      viewModel: _ctx.weightsSetDeleter,
      onDeleteWeightsSet: _ctx.handleDeleteWeightsSetCommand
    }, null, 8 /* PROPS */, ["viewModel", "onDeleteWeightsSet"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.rm)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Loading... ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.rm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[24] || (_cache[24] = _createElementVNode("a", {
              class: "btn btn-outline-secondary float-right",
              href: "https://www.transparentchoice.com/user-guide/weight-criteria",
              title: "User guide: Criteria weights",
              target: "_blank"
            }, [
              _createElementVNode("i", {
                class: "fa fa-info",
                "aria-hidden": "true"
              })
            ], -1 /* CACHED */)),
            _createElementVNode("h3", null, "Goal: " + _toDisplayString(_ctx.rm.GoalName), 1 /* TEXT */),
            _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createVNode(_component_GoalNavigation, {
              ActivePage: "criteria-surveys",
              WorkspaceId: _ctx.workspaceId,
              ProjectId: _ctx.projectId,
              EvalModelId: _ctx.evalModelId,
              ScoringEnabled: _ctx.rm.ScoringEnabled
            }, null, 8 /* PROPS */, ["WorkspaceId", "ProjectId", "EvalModelId", "ScoringEnabled"]),
            _createElementVNode("div", _hoisted_4, [
              _cache[11] || (_cache[11] = _createElementVNode("button", {
                class: "btn btn-success dropdown-toggle",
                type: "button",
                "data-toggle": "dropdown"
              }, " Create ", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showSurveyCreator && _ctx.showSurveyCreator(...args)))
                }, "Opinion panel"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showWeightsSetCreator && _ctx.showWeightsSetCreator(...args)))
                }, "Weights set"),
                (!_ctx.rm.ScoringEnabled)
                  ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("Weighted score", -1 /* CACHED */)
                    ]))])), [
                      [_directive_sanitizedHref, _ctx.url_CreateWeightedScorePage]
                    ])
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[12] || (_cache[12] = _createElementVNode("button", {
                class: "btn btn-outline-secondary dropdown-toggle",
                type: "button",
                "data-toggle": "dropdown"
              }, " Export to xls ", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.DownloadVotesCommand && _ctx.DownloadVotesCommand(...args)))
                }, "Votes"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleExportAllWeightsToXlsCommand && _ctx.handleExportAllWeightsToXlsCommand(...args)))
                }, "Weights")
              ])
            ]),
            _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surveysView, (s) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-lg-4 col-md-6 col-sm-6 col-xs-12",
                  key: s.Id
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("h5", _hoisted_12, [
                        (!s.SurveyStarted)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                          : (_openBlock(), _createElementBlock("i", _hoisted_14)),
                        _createTextVNode(" " + _toDisplayString(s.Name), 1 /* TEXT */)
                      ]),
                      _createElementVNode("p", _hoisted_15, [
                        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_16, [
                          _createTextVNode(" Panelists: " + _toDisplayString(s.RespondentsCount), 1 /* TEXT */)
                        ])), [
                          [_directive_sanitizedHref, _ctx.url_CriteriaPanelistsPage(s)]
                        ]),
                        _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("a", {
                          class: "text-primary",
                          onClick: ($event: any) => (_ctx.showSubSurveysManager(s.Id))
                        }, " Combined panels: " + _toDisplayString(s.SubSurveysCount), 9 /* TEXT, PROPS */, _hoisted_17)
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_18, [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("Review", -1 /* CACHED */)
                      ]))])), [
                        [_directive_sanitizedHref, _ctx.url_CriteriaMeetingManagerPage(s)]
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[18] || (_cache[18] = _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-secondary dropdown-toggle",
                          type: "button",
                          "data-toggle": "dropdown"
                        }, " Actions ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showSurveyEditor(s.Id))
                          }, "Edit", 8 /* PROPS */, _hoisted_21),
                          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          (!s.SurveyStarted)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.showSurveyOpener(s.Id))
                              }, "Open survey", 8 /* PROPS */, _hoisted_22))
                            : _createCommentVNode("v-if", true),
                          (s.SurveyStarted)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.showSurveyCloser(s.Id))
                              }, "Close survey", 8 /* PROPS */, _hoisted_23))
                            : _createCommentVNode("v-if", true),
                          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showSurveyWeightsViewer(s.Id))
                          }, "View weights", 8 /* PROPS */, _hoisted_24),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showSurveyWeightsComparer(s.Id))
                          }, "Compare weights", 8 /* PROPS */, _hoisted_25),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showSurveyWeightsSetCreator(s))
                          }, "Create weights set", 8 /* PROPS */, _hoisted_26),
                          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showSurveyDeleter(s.Id))
                          }, "Delete", 8 /* PROPS */, _hoisted_27)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("button", {
              role: "button",
              class: "btn btn-outline-secondary mb-1",
              disabled: _ctx.selectedWeightsSets.length === 0,
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showWeightsSetsWeightsComparer && _ctx.showWeightsSetsWeightsComparer(...args)))
            }, " Compare (" + _toDisplayString(_ctx.selectedWeightsSets.length) + ") ", 9 /* TEXT, PROPS */, _hoisted_28),
            _createElementVNode("table", _hoisted_29, [
              _cache[23] || (_cache[23] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { style: {"width":"30px"} }),
                  _createElementVNode("th", null, [
                    _createElementVNode("span", null, "Weights set")
                  ]),
                  _createElementVNode("th", { style: {"width":"180px"} }, [
                    _createElementVNode("span", null, "Updated on")
                  ]),
                  _createElementVNode("th", { style: {"width":"180px"} }, [
                    _createElementVNode("span", null, "Created on")
                  ]),
                  _createElementVNode("th", { style: {"width":"90px"} })
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weightsSetsView, (ws) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: ws.Id
                  }, [
                    _createElementVNode("td", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input mr-0",
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((ws.IsSelected) = $event)
                        }, null, 8 /* PROPS */, _hoisted_32), [
                          [_vModelCheckbox, ws.IsSelected]
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        class: "text-dark",
                        onClick: ($event: any) => (_ctx.showWeightsSetEditor(ws))
                      }, [
                        _createTextVNode(_toDisplayString(ws.Name) + " ", 1 /* TEXT */),
                        (ws.Id === _ctx.defaultWeightsSetId)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Default"))
                          : _createCommentVNode("v-if", true)
                      ], 8 /* PROPS */, _hoisted_33)
                    ]),
                    _createElementVNode("td", _hoisted_35, [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(ws.Modified)), 1 /* TEXT */),
                      _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("small", null, _toDisplayString(_ctx.formatTime(ws.Modified)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", _hoisted_36, [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(ws.Created)), 1 /* TEXT */),
                      _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("small", null, _toDisplayString(_ctx.formatTime(ws.Created)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_37, [
                        _cache[22] || (_cache[22] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, [
                          _createTextVNode(" Actions "),
                          _createElementVNode("span", { class: "caret" })
                        ], -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showWeightsSetEditor(ws))
                          }, "Edit", 8 /* PROPS */, _hoisted_39),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showWeightsSetWeightsViewer(ws.Id))
                          }, "View weights", 8 /* PROPS */, _hoisted_40),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.handleChangeDefaultWeightsSetCommand(ws.Id))
                          }, "Set as default", 8 /* PROPS */, _hoisted_41),
                          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showWeightsSetDependencies(ws))
                          }, "View dependencies", 8 /* PROPS */, _hoisted_42),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showWeightsSetDeleter(ws))
                          }, "Delete", 8 /* PROPS */, _hoisted_43)
                        ])
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}